import React, { Component } from 'react';
import SoundRepository from '../../game/handlers/SoundRepository';
import db_fb from '../../firebase/firebaseUse';
import loading from '.././../media/images/icons/loading.gif';
import OfflineMessage from '../../small-components/offline-message/OfflineMessage';
import MuteButton from '../../small-components/mute-button/MuteButton';
import goldPlate from '../../media/images/icons/gold-plate.png';
import silverPlate from '../../media/images/icons/gray-plate.png';
import bronzePlate from '../../media/images/icons/bronze-plate.png'
import PrevButton from '../../small-components/prev-button/PrevButton';
import Constants from '../../game/constants/Constants';
import './ChampionsPage.css';

class ChampionsPage extends Component {

    constructor(props) {
        super(props);
        this.soundRepository = SoundRepository;
        this.state = {
            championes: [],
            bool_offline_msg: navigator.onLine
        }
    }

    componentWillMount() {
        window.addEventListener('offline', () => {
            this.setState({ bool_offline_msg: false })
        })

        window.addEventListener('online', () => {
            this.setState({ bool_offline_msg: true })
        })

        this.retrieveChampionsList();
    }

    componentWillUnmount() {
        this.soundRepository.stopSoundByName(Constants.SOUND_CHAMPIONS_PAGE);
    }

    retrieveChampionsList = async () => {
        let champions = await db_fb.getDataFromFB('champions');
        champions = champions.val();
        let championesArr = Object.values(champions);
        let sorted_championesArr = championesArr.sort((a, b) => b.score - a.score);

        this.setState({ championes: sorted_championesArr });
    }

    render() {
        let content;
        if (!this.state.bool_offline_msg) {
            content = <OfflineMessage />;
        }

        else if (this.state.championes.length > 0) {
            this.soundRepository.playSoundByName(Constants.SOUND_CHAMPIONS_PAGE);

            content =
                <div className="championes-flex">
                    <div>
                        <h1 className="championes-title">טבלת האלופים</h1>
                    </div>
                    <div className="table-container">
                        <table className="champions-table">
                            <tbody>
                                <tr className="championes-table-top-line">
                                    <th>#</th>
                                    <th>שם</th>
                                    <th>ניקוד</th>
                                    <th>צלחת</th>
                                </tr>
                                {this.state.championes.map((obj, index) => (
                                    <tr key={index} className="championes-table-lines">
                                        <td>{index + 1}</td>
                                        <td>{obj.name}</td>
                                        <td>{obj.score}</td>
                                        <td>
                                            <img
                                                draggable="false"
                                                alt={!index || index === 1 ? "plate-level" : ''}
                                                src={!index ? goldPlate : index === 1 ? silverPlate : bronzePlate} />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>;
        }
        else {
            content =
                <div className="flex-parent">
                    <img className="waitingLogo" draggable="false" src={loading} alt="loading..." />
                </div>;
        }

        return (
            <div className='page'>

                <MuteButton />
                <PrevButton pageProps={this.props} />

                {content}

            </div>
        );
    }
}



export default ChampionsPage;
